export default __webpack_public_path__ + "static/media/smartcryptoblack.1106a29b.svg";